// Store the pointer pos here instead of redux because redux
// causes a react-redux re-render of everything

import EventEmitter from '../../event/EventEmitter';

const eventEmitters = {}; // domainName -> eventEmitter

// Events
const UPDATE_LAST_POINTER_POS = 'UPDATE_LAST_POINTER_POS';

export function updateLastPointerPos(domainName, lastPointerPos) {
  if (domainName in eventEmitters) {
    eventEmitters[domainName].emit(UPDATE_LAST_POINTER_POS, lastPointerPos);
  }
}

export function subscribe(domainName, callback) {
  if (!(domainName in eventEmitters)) {
    eventEmitters[domainName] = new EventEmitter();
  }

  eventEmitters[domainName].on(UPDATE_LAST_POINTER_POS, callback);
}

export function unsubscribe(domainName, callback) {
  if (domainName in eventEmitters) {
    eventEmitters[domainName].off(UPDATE_LAST_POINTER_POS, callback);
  }
}

export function unsubscribeAll(domainName) {
  if (domainName in eventEmitters) {
    eventEmitters[domainName].offAll();
  }
}
